import Forms from './_forms';

const $ = window.jQuery;
const customer_tab = $('#customer_tab');
const reseller_tab = $('#reseller_tab');
const customer_content = $('#customer_tab_content');
const reseller_content = $('#reseller_tab_content');
const tabs= customer_tab.add(reseller_tab);
const tab_contents = customer_content.add(reseller_content);


new Forms();

function HomeTabs()  {

	var self = this;

	self.setListeners = function() {
		tabs.on('click', function() {
			if (!this.classList.contains('_active')) {
				self.switchHomeTabs();
			}
		});
	},

	self.switchHomeTabs = function() {
		tabs.toggleClass('_active');
		tab_contents.toggle();
	},

	self.showHomeTab = function() {
		if (window.location.hash.substring(1)=="resellers") {
			reseller_tab.addClass('_active');
			reseller_content.show();
		}

		else {
			customer_tab.addClass('_active');
			customer_content.show();
		} 
	}

	self.init = function() {

		self.setListeners();
		self.showHomeTab();
	}
}

var homeTabs = new HomeTabs();
homeTabs.init();











// WEBPACK FOOTER //
// ./src/js/index.js